import { AxiosRequestConfig } from "axios";
import ApiConstants from "../constants/ApiConstants";
import http from "../http";


class PayrollLiabilityService {
    
    static apiConfig;
    static getReport() {
        let params = this.apiConfig;
        let url = ApiConstants.URL.REPORT.PAYROLL_LIABILITY_REPORT;
        if(params) {
            let paramStr = '';
            let keys = Object.keys(params);
            keys.forEach((key,index)=>{
                if(index == 0) {
                    paramStr = `?${[key]}=${params[key]}`
                } else {
                    paramStr = paramStr + `&${[key]}=${params[key]}`
                }
                
            })
            url = url + paramStr
          }
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                console.error('Error loading report ', err);
                return Promise.reject(err);
            });
    }
}

export default PayrollLiabilityService;
